import { Action } from 'redux';
import { ActiveItem } from '../components/venue-management/types';
import { Dispatch } from 'react';

// Action types
export const NAVIGATE_TO = 'VENUE_MANAGEMENT_NAVIGATE_TO';
export type NAVIGATE_TO = typeof NAVIGATE_TO;

export const SET_ACTIVE_ITEM_TOUCHED = 'SET_ACTIVE_ITEM_TOUCHED';
export type SET_ACTIVE_ITEM_TOUCHED = typeof SET_ACTIVE_ITEM_TOUCHED;

export interface LoadVenueDetails extends Action {
    type: NAVIGATE_TO;
    payload: ActiveItem;
}

export interface SetActiveItemTouched extends Action {
    type: SET_ACTIVE_ITEM_TOUCHED;
    payload: boolean;
}

export type VenueManagementAction = LoadVenueDetails | SetActiveItemTouched;

export function navigateTo(target: ActiveItem) {
    return (dispatch: Dispatch<LoadVenueDetails>) => {
        dispatch({
            type: NAVIGATE_TO,
            payload: target,
        });
    };
}

export function setActiveItemTouched(touched: boolean) {
    return (dispatch: Dispatch<SetActiveItemTouched>) => {
        dispatch({
            type: SET_ACTIVE_ITEM_TOUCHED,
            payload: touched,
        });
    };
}
